define('LoginForPriceUrlRedirection', [
  'UrlHelper'
], function (
  UrlHelper
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layoutComponent = container.getComponent('Layout');

      if(layoutComponent) {
        layoutComponent.addToViewContextDefinition('ProductViews.Price.View', 'urlLogin', 'string', function urlLoginContext(context) {
          var loginUrl = context.urlLogin;
          var urlComponent = context && context.model && context.model.item && context.model.item.urlcomponent || '';
          try {
            loginUrl = UrlHelper.UrlHelper.setUrlParameter(loginUrl, 'origin_hash', urlComponent);
          } catch (exc) {
            console.log('LFPR01: There was an error while processing the url component of the login link\n\n' + exc);
          }
          return loginUrl;
        });
      }

    }
  };
});
